import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import {Button, Stack} from "@mui/material";
import {ReactComponent as Hand} from "../../assets/hand.svg";
import classNames from "classnames";
import api from "../../api";
import {handleErrorConfirm} from "../../utils/handlerError";
import CheckIcon from '@mui/icons-material/Check';
import {toast} from "react-toastify";

const Header = ({openModal, headerData, disabled}) => {

    const handlerStop = async () => {
        const token = localStorage.getItem('token')
        try {
            const res = await api().get(`coach/hand/${token}`)

            if (res?.data?.status === 'error') {
                handleErrorConfirm(res?.data?.error || 'Ошибка')
                return
            }
            toast.success('Просьба о помощи отправлена', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } catch (e) {
            console.log(e)
            toast.error('Ошибка', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }
    return (
        <div className={s.header}>
            <div className={s.left_header} style={headerData?.couch_type_id !== null ? undefined : {width: '100%'}}>
                <div className={s.left_header_top}>
                    <div className={s.name_1}>
                        <Stack sx={{
                                   maxWidth: '130px',
                                   width: '130px',
                                   minWidth: '130px',
                                   display: 'inline-block',
                                   whiteSpace: 'nowrap',
                                   textOverflow: 'ellipsis',
                                   overflow: 'hidden'
                               }}>
                            {headerData?.couch_type_name_short || '...'}
                        </Stack>
                    </div>
                    <div className={s.name_2}>
                        <Stack sx={{
                            maxWidth: '100%',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                        }}>
                            {headerData?.competition_name || '...'}
                        </Stack>
                    </div>
                </div>
                <div className={s.left_header_bottom}>
                    <div className={s.name_3}>{headerData?.age_group_discipline_short || '...'}</div>
                    <div className={s.name_4}>{headerData?.competition_draw || '...'}</div>
                    <div className={s.name_5}>
                        <Stack sx={{
                            maxWidth: '100%',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                        }}>
                            {headerData?.competition_application_name || '...'}
                        </Stack>
                    </div>
                </div>
            </div>
            {headerData?.couch_type_id !== null && <div className={s.right_header}>
                <div className={s.hand} onClick={handlerStop}>
                    <Hand/>
                </div>
                <div className={classNames(s.btn)}>
                    <Button variant="contained" onClick={openModal} disabled={disabled} sx={{
                        height: '100%',
                        width: '100%'
                    }}>
                        <CheckIcon sx={{fontSize: 80}}/>
                    </Button>
                </div>
            </div>}
        </div>
    );
};

export default Header;
